module.exports = __webpack_public_path__ + "h5/img/qr-code.7312b1ef.jpg";